
import { language } from 'curvy';

export const english: language.TranslationDefinition = {
    locale: 'en-us',
    translations: {
        'LABEL.FLAG': 'Labels',
        'LABEL.FLAG.EDIT': (name) => 'Edit label ' + name,
        'LABEL.FLAG.LONG.NAME': 'Long name',
        'LABEL.FLAG.SHORT.NAME': 'Short name',
        'LABEL.FLAG.APPLY': 'Apply',
        'LABEL.FLAG.STATUS': 'Status',
        'LABEL.FLAG.SUPPLIERS': 'Suppliers',
        'LABEL.FLAG.ADD_NEW': 'Add order flag',
        'LABEL.FLAG.ORDER': 'Order',
        'LABEL.FLAG.SCHEDULE.ORDER': 'Service',
        'LABEL.FLAG.TICKET': 'Ticket',
        'LABEL.FLAG.SUPPLIER': 'Supplier',
        'LABEL.FLAG.SUPPLIER.YES': 'Yes',
        'LABEL.FLAG.SUPPLIER.NO': 'No',
        'LABEL.FLAG.ERROR.DUPLICATE_SHORT_NAME': 'Short name already exists',
        "LABEL.FLAG.DELETE.TITLE": "Delete label",
        "LABEL.FLAG.DELETE.CONTENT": (name) => `Are you sure you want to delete the label ${name}?`,
        'LABEL.FLAG.STATUS.ACTIVE': 'Active',
        'LABEL.FLAG.STATUS.DELETED': 'Deleted',
        'LABEL.FLAG.ERROR.COMPANY_REQUIRED': 'Company is required',
    }
};

export const croatian: language.TranslationDefinition = {
    locale: 'hr-hr',
    translations: {
        'LABEL.FLAG': 'Oznake',
        'LABEL.FLAG.EDIT': (name) => 'Izmjena oznake ' + name,
        'LABEL.FLAG.LONG.NAME': 'Dugi naziv',
        'LABEL.FLAG.SHORT.NAME': 'Kratki naziv',
        'LABEL.FLAG.APPLY': 'Primjena',
        'LABEL.FLAG.STATUS': 'Status',
        'LABEL.FLAG.SUPPLIERS': 'Dobavljači',
        'LABEL.FLAG.ADD_NEW': 'Dodaj oznaku',
        'LABEL.FLAG.ORDER': 'Nalog',
        'LABEL.FLAG.SCHEDULE.ORDER': 'Servis',
        'LABEL.FLAG.TICKET': 'Prijava',
        'LABEL.FLAG.SUPPLIER': 'Dobavljač',
        'LABEL.FLAG.SUPPLIER.YES': 'Da',
        'LABEL.FLAG.SUPPLIER.NO': 'Ne',
        'LABEL.FLAG.ERROR.DUPLICATE_SHORT_NAME': 'Kratki naziv već postoji',
        "LABEL.FLAG.DELETE.TITLE": "Obriši oznaku",
        "LABEL.FLAG.DELETE.CONTENT": (name) => `Da li ste sigurni da želite obrisati oznaku ${name}?`,
        'LABEL.FLAG.STATUS.ACTIVE': 'Aktivan',
        'LABEL.FLAG.STATUS.DELETED': 'Obrisan',
        'LABEL.FLAG.ERROR.COMPANY_REQUIRED': 'Tvrtka je obavezna',
    }
};

export const label_flags_translations = [english, croatian];
